import { FC } from 'react'
import { Link } from 'react-router-dom'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useFormattedDate } from '../hooks'
import { InfoArea } from '../primitives'
import { ArpFavoriteButton } from './ArpFavoriteButton'
import { ArpPlabackButton } from './ArpPlaybackButton'

export const ArpTokenInfo: FC<{ media: IArpMedia }> = ({ media }) => {
  const { metadata, user, createdAt } = media
  const date = useFormattedDate(createdAt)
  return (
    <InfoArea.Root>
      <InfoArea.TitleText>{metadata.title}</InfoArea.TitleText>
      <ArpPlabackButton media={media} />
      <ArpFavoriteButton media={media} />
      <InfoArea.ArtistSection as={Link} to={`/profile/${user.walletAddress}`}>
        <InfoArea.ArtistAvatar src={user.profilePicture?.url} />
        <InfoArea.ArtistText>{user.displayName}</InfoArea.ArtistText>
        <InfoArea.DateText>{`• ${date}`}</InfoArea.DateText>
      </InfoArea.ArtistSection>
    </InfoArea.Root>
  )
}
